export const SITE_LOGO = 'site-logo'
export const RF_NO_DISTRACTIONS = 'rf-no-distractions'
